import React from 'react'

const Postervideo = (props) => {
    const handleClick=()=>{
        props.setcuerrentVideo(props.val)
    }

    const VideoOff = ()=>{
        props.setplaying(false)
    }


    return (
        <>
                <div className="col-md-3 col-lg-3 col-sm-6 col-12 gy-5">
                    <div className="poster_video" onClick={handleClick} >
                    <h3>{props.title}</h3>
                    <img src={props.thumb} className="img-fluid" id='thumb'width='300px' height='250px' onClick={VideoOff} />
                    <h6>{props.subtitle}</h6>
                    <p>{props.description}</p>
                </div>
                </div>
        </>
    )
}

export default Postervideo
